// extracted by mini-css-extract-plugin
module.exports = {"root":"EventPage_root__YxdW7","mapContainer":"EventPage_mapContainer__Twkhw"};